module.exports = __webpack_public_path__ + "82492cdfc79eac6d95fa2a38328dad64.MP3";